var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5303_684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7715 16.7129L13.303 12.2444C14.5207 10.7551 15.1194 8.85473 14.9753 6.93638C14.8311 5.01802 13.9552 3.22845 12.5286 1.93782C11.102 0.647195 9.23391 -0.04574 7.31074 0.00234512C5.38758 0.0504302 3.55647 0.835856 2.19616 2.19616C0.835856 3.55647 0.0504302 5.38758 0.00234512 7.31074C-0.04574 9.23391 0.647195 11.102 1.93782 12.5286C3.22845 13.9552 5.01802 14.8311 6.93638 14.9753C8.85473 15.1194 10.7551 14.5207 12.2444 13.303L16.7129 17.7715C16.782 17.843 16.8646 17.9 16.9559 17.9392C17.0472 17.9785 17.1455 17.9991 17.2449 18C17.3443 18.0008 17.4429 17.9819 17.5349 17.9443C17.6269 17.9066 17.7104 17.851 17.7807 17.7807C17.851 17.7104 17.9066 17.6269 17.9443 17.5349C17.9819 17.4429 18.0008 17.3443 18 17.2449C17.9991 17.1455 17.9785 17.0472 17.9392 16.9559C17.9 16.8646 17.843 16.782 17.7715 16.7129ZM7.51015 13.4991C6.32564 13.4991 5.16774 13.1478 4.18286 12.4898C3.19799 11.8317 2.43037 10.8964 1.97708 9.80202C1.52379 8.70768 1.40519 7.5035 1.63627 6.34176C1.86736 5.18002 2.43775 4.11289 3.27532 3.27532C4.11289 2.43775 5.18002 1.86736 6.34176 1.63627C7.5035 1.40519 8.70768 1.52379 9.80202 1.97708C10.8964 2.43037 11.8317 3.19799 12.4898 4.18286C13.1478 5.16774 13.4991 6.32564 13.4991 7.51015C13.4991 9.09851 12.8681 10.6218 11.745 11.745C10.6218 12.8681 9.09851 13.4991 7.51015 13.4991Z",
    fill: "#696969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5303_684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.412394983bc6986c4a9ca88c26e5dea0.svg";
export { ForwardRef as ReactComponent };